import type { FC } from 'react';
import { FullScreenButton } from './FullScreenButton';
import { PlaybackButton } from './PlaybackButton';

import S from './styles.base.module.scss';

/**
 * The custom player icons that can be overlayed over the video.
 * @param progress - Current progress of the video (0-1 value).
 * @returns ProgressIndicator component.
 */
export const PlayerOverlay: FC = () => {
  return (
    <div className={S.overlay}>
      <div className={S.icons}>
        <PlaybackButton />
        <FullScreenButton />
      </div>
    </div>
  );
};
